import React, { useEffect, useState } from "react";
import { useDeleteInterestScheduleMutation } from "../../../../../../services/RTKQuery/interestSchedules";
import { InterestSchedule } from "../../../../../../services/RTKQuery/ModelTypes/interestSchedule"; // Assuming the correct path

export const DeleteTest = ({ scheduleUuid, loanUuid, setStatusInParent }) => {
  const statusUnknown = "❓Unknown Status";
  const statusPass = "✅ Pass";
  const statusFail = "❌ Fail";

  const [statusReadSingle, setStatus] = useState(statusUnknown);
  const [detailsText, setDetailsText] = useState("statusUnknown");

  const [deleteScheduleTrigger] = useDeleteInterestScheduleMutation();
  useEffect(() => {
    const scheduleToDelete: Partial<InterestSchedule> = {
      uuid: scheduleUuid,
      loan_uuid: loanUuid
    };
    deleteScheduleTrigger(scheduleToDelete)
      .unwrap()
      .then(fulfilled => {
        if (
          fulfilled?.data?.uuid === scheduleUuid &&
          fulfilled?.data?.deleted === true
        ) {
          setStatus(statusPass);
          setDetailsText(`: Soft deleted item: ${scheduleUuid}`);
          setStatusInParent("Pass");
        } else {
          console.error("delete fulfilled: ", fulfilled);
          setStatus(statusFail);
          setDetailsText(`: Did NOT delete item: ${scheduleUuid}`);
          setStatusInParent("Fail");
        }
      })
      .catch(error => {
        console.error("Fail: useDeleteInterestScheduleMutation", error);
        setStatus(statusFail);
        setStatusInParent("Fail");
      });
  }, [deleteScheduleTrigger, loanUuid, scheduleUuid, setStatusInParent]);

  return (
    <>
      <b>{statusReadSingle}</b>
      <small>{detailsText}</small>
    </>
  );
};
